import { render, staticRenderFns } from "./CsrContent2.vue?vue&type=template&id=35362760&scoped=true"
import script from "./CsrContent2.vue?vue&type=script&lang=js"
export * from "./CsrContent2.vue?vue&type=script&lang=js"
import style0 from "./CsrContent2.vue?vue&type=style&index=0&id=35362760&prod&scoped=true&lang=css"
import style1 from "./CsrContent2.vue?vue&type=style&index=1&id=35362760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35362760",
  null
  
)

export default component.exports